// My Friends
export const selectFriends = (state) => state.friends.myFriends
export const selectFriendsNextLink = (state) => state.friends.myFriendsNextLink
export const selectNoFriends = (state) => state.friends.noFriends
export const selectFriendsLoading = (state) => state.friends.myFriendsLoading
export const selectMoreFriendsLoading = (state) => state.friends.getMoreFriendsLoading
export const selectFriendRequests = (state) => state.friends.myFriendRequests
export const selectUserToUnfriend = (state) => state.friends.userToUnfriend
export const selectConfirmUnfriend = (state) => state.friends.confirmUnfriend
export const selectIdCurrentlyInFriendAcceptLoadingState = (state) => state.friends.userIdCurrentlyAccepting
export const selectRemoveFriendIsLoading = (state) => state.friends.removeFriendIsLoading
export const selectTotalFriends = (state) => state.friends.totalFriends
export const selectIsDenyingFriendRequest = (state) => state.friends.isDenyingFriendRequest

// Find Friends
export const selectFindFriendsLoading = (state) => state.friends.findFriendsLoading
export const selectPendingFriendRequests = (state) => state.friends.pendingFriendRequests
export const selectSuggestedFriends = (state) => state.friends.suggestedFriends
export const selectSuggestedFriendsLoading = (state) => state.friends.isGettingMoreSuggestedFriends
export const selectSearchResults = (state) => state.friends.searchResults
export const selectSearchLoading = (state) => state.friends.searchLoading
export const selectNoSearchResults = (state) => state.friends.noSearchResults
export const selectUserIdCurrentlyAdding = (state) => state.friends.userIdCurrentlyAdding
export const selectNoMoreSuggestions = (state) => state.friends.noMoreSuggestions
